import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isAtBottom, setIsAtBottom] = useState(false);

    // 스크롤 위치에 따라 버튼 표시/숨김
    useEffect(() => {
        const toggleVisibility = () => {
            const scrollTop = window.pageYOffset;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            
            // 상단 버튼 표시 조건 (300px 이상 스크롤)
            setIsVisible(scrollTop > 300);
            
            // 하단 버튼 표시 조건 (페이지 하단 근처가 아닐 때)
            setIsAtBottom(scrollTop + windowHeight >= documentHeight - 100);
        };

        window.addEventListener('scroll', toggleVisibility);
        toggleVisibility(); // 초기 상태 설정

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    // 최상단으로 스크롤
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // 최하단으로 스크롤
    const scrollToBottom = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
        });
    };

    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
            {/* 최상단으로 이동 버튼 */}
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="bg-slate-900 hover:bg-slate-800 text-white rounded-full p-3 shadow-xl transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2"
                    aria-label="맨 위로 이동"
                >
                    <svg 
                        className="w-6 h-6" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M5 10l7-7m0 0l7 7m-7-7v18" 
                        />
                    </svg>
                </button>
            )}

            {/* 최하단으로 이동 버튼 */}
            {!isAtBottom && (
                <button
                    onClick={scrollToBottom}
                    className="bg-gray-600 hover:bg-gray-700 text-white rounded-full p-3 shadow-xl transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    aria-label="맨 아래로 이동"
                >
                    <svg 
                        className="w-6 h-6" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M19 14l-7 7m0 0l-7-7m7 7V3" 
                        />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default ScrollToTopButton;
